import { gql } from '@grandvisionhq/graphql';

const storeOfferByCode = gql`
  fragment StoreOfferByCode on Store {
    offers {
      title
      description
      url
      imageUrl
    }
  }
`;
const GET_STORE_OFFER_BY_CODE = gql`
  query GetStoreOfferByCode($code: Int) {
    store(code: $code) {
      ...StoreOfferByCode
    }
  }
  ${storeOfferByCode}
`;

export { GET_STORE_OFFER_BY_CODE };
//# sourceMappingURL=get-store-offer-by-code.js.map
